module.exports = __webpack_public_path__ + "img/DSC_0060.ed8c56f1.jpg";